'use strict';

customerZone.controller('MyOrdersController', ['$q', '$log', '$location', 'utils', 'config',
    'OrderService', 'ProductService', 'SubscriptionService', 'errorCode', function( $q, $log, $location, utils,
        config, OrderService, productService, subscriptionService, errorCode){

        var self = this;
        self.loading = false;
        self.paymentMethodSelection = null; // this will be injected by the paymentMethodSelection component

        self.polledOrder = '';

        var POLL_INTERVAL_MSECS = 1500;

        var getAwaitingOrders = function() {
            self.loading = true;
            OrderService.getAwaitingOrders().then(
                function (orders) {
                    self.awaitingOrders = orders;
                    self.loading = false;
                })
                .catch(function (error) {
                    $log.error('could not load orders', error);
                    utils.showError();
                });
        };


        /**
         * Provides a url to redirect to after payment is completed, depending on the order type.
         * @param order
         * @return {string} the url depending on the order's type
         */
        var determineReturnUrl = function(order){
            if (order.type === jim.OrderType.ORDER_A_SIM) {
                return config.eserviceUrl+'#!/registration/sales?order='+order.id;
            }
            else if (order.type === jim.OrderType.ORDER_A_TOPUP) {
                return config.eserviceUrl+'#!/reload?order='+order.id;
            }
            else if (order.type === jim.OrderType.ORDER_A_MIGRATION) {
                return config.eserviceUrl+'#!/migration?order='+order.id;
            }
            else if (order.type === jim.OrderType.ORDER_A_PACKAGE) {
                return config.eserviceUrl+'#!/my_orders?order='+order.id;
            }
            $log.error('payment made with no proper order type', order.type);
            return config.eserviceUrl+'#!/my_orders?order='+order.id;
        };

        function continueOnboarding(order) {
            var url = config.eserviceUrl + '#!/registration/sales?order=' + order.id;
            utils.redirect(url);
        }

        self.payOrder = function(order){
            if (order.type === jim.OrderType.ORDER_A_SIM){
                continueOnboarding(order);
                return $q(function(){});
            }
            var url = determineReturnUrl(order);
            return subscriptionService.payOutstandingOrder(order, self.paymentMethodSelection.getPaymentMethod, url)
                .then(function(order){
                    if (order.paymentUrl){
                        utils.redirect(order.paymentUrl);
                    }
                    else {
                        $location.search('order', order.id);
                        pollOrderState(order.id);
                    }
                }, function(error){
                    if (errorCode.is(error, errorCode.WRONG_STATE)) {
                        $log.debug('Requested order is no longer payable');
                        self.awaitingOrders.splice(self.awaitingOrders.indexOf(order), 1);
                    }
                    else {
                        $log.error('Failed to pay awaiting order: ', error);
                        utils.showError();
                    }
                });
        };

        var pollOrderState = function(orderId){

            var getOrderState = function(){
                return subscriptionService.getOrder(orderId);
            };

            var untilNotWaitingForPayment = function(order){
                if (!order.state) return false;
                if (order.state === jim.OrderState.waiting_for_payment) return false;
                return true;
            };

            utils.poll(getOrderState, untilNotWaitingForPayment, POLL_INTERVAL_MSECS, 10000, 'paying order')
                .then(function(){
                    self.polledOrder = '';
                    getAwaitingOrders();
                }).catch(function(error){
                    $log.error('Failure when trying to pay an awaiting order', error);
                    utils.showError();
                });
        };

        var init = function(){

            var orderId = $location.search()['order'];
            if (orderId){
                self.polledOrder = orderId;
                pollOrderState(orderId);
            }

            getAwaitingOrders();
        };

        init();

    }]);
